export default "__VITE_ASSET__RVxM$7iR__"